// extracted by mini-css-extract-plugin
export default {"field":"UsernameEditPopup_field__7utkf","text":"UsernameEditPopup_text__81rgu"};